export const defaultSidebarMenuConfig = [
    {
        label: "Management",
        items: [
            {
                menuKey: "dashboard",
                menuTitle: "Dashboard",
                menuIcon: "lucide:layout-dashboard",
                navigationPath: "/dashboard",
            },
            {
                menuKey: "attendance",
                menuTitle: "Attendance",
                menuIcon: "lucide:calendar-check",
                navigationPath: "/attendance-history",
            },
        ],
    },
    {
        label: "Teacher / HOD Student Attendance",
        items: [
            {
                menuKey: "teacherHodAttendance",
                menuTitle: "Student Management",
                menuIcon: "ph:student-fill",
                children: [
                    {
                        menuKey: "studentAttendanceDashboard",
                        subMenuName: "Dashboard",
                        navigationPath: "/student-management/dashboard",
                    },
                    {
                        menuKey: "studentAttendance",
                        subMenuName: "Student Attendance Register",
                        navigationPath: "/student-management/attendance",
                    },
                    {
                        menuKey: "studentAttendanceReport",
                        subMenuName: "Student Attendance Report",
                        navigationPath: "/student-management/report",
                    },
                ],
            },
        ],
    },
];
